module.exports = __webpack_public_path__ + "img/academy64_ua.982efe83.webp";